import Iso from "../../views/modules/iso/Iso";
import DocumentList from "../../views/modules/iso/documents/DocumentList";
import CategoriesList from "../../views/modules/iso/categories/CategoriesList";
import KPI from "../../views/modules/iso/KPI";

import layouts from "../../layout";

export default {
  path: "/iso",
  name: "iso",
  component: Iso,
  meta: {
    auth: true
  },
  redirect: {
    name: "iso-document"
  },
  children: [
    {
      path: "documents",
      name: "iso-document",
      component: DocumentList,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Documents",
        tags: ["iso", "documents"],
        index: true
      }
    },
    {
      path: "categories",
      name: "iso-categories",
      component: CategoriesList,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Categories",
        tags: ["iso", "categories"],
        index: true
      }
    },
    {
      path: "kpi",
      name: "iso-kpi",
      component: KPI,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "KPI",
        tags: ["iso", "kpi"],
        index: true
      }
    }
  ]
};
